/**
 * 用户相关
 */
import $config from "@/config/index";
import { setLocalStorage, getLocalStorage } from "@/common/js/mUtils";
import {
  getUserPermission,
  getUserInfo,
  login,
  loginByOA,
  h5InvestLoginByApp,
  getOssToken,
} from "@/api/index";
import { Base64 } from "js-base64";
import Router from "@/router";

const state = {
  oauth: {},
  permissionsList: [],
  userData: {},
  userId: "",
  ossConfig: {}, // oss配置信息
};

const actions = {
  /**
   * 获取oss config参数用于文件上传
   * @param state
   * @param commit
   * @constructor
   */
  getOssToken({ state, commit }) {
    return new Promise((resolve, reject) => {
      // 判断是否存在且未过期
      let oldTime =
        state.ossConfig && state.ossConfig.oldTime
          ? state.ossConfig.oldTime
          : null;
      let nowTime = Number(new Date());
      // 有可用oss config则直接返回
      if (oldTime && nowTime - oldTime < 600000) {
        resolve(state.ossConfig);
        return;
      }
      // 否则通过接口请求配置参数
      getOssToken()
        .then((res) => {
          let data = {
            stsToken: res.body.SecurityToken,
            accessKeyId: res.body.AccessKeyId,
            accessKeySecret: res.body.AccessKeySecret,
            bucket: res.body.bucket,
            region: res.body.region.split(".")[0],
            oldTime: Number(new Date()), // 扩展个时间参数
          };
          resolve(data);
          commit("UPDATE_OSS_TOKEN", data);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  /**
   * 登陆操作
   * */
  doLogin({ commit, dispatch }, formData) {
    return new Promise((resolve, reject) => {
      login(formData)
        .then((res) => {
          commit("UPDATE_OAUTH", res.body);
          // 获取权限
          dispatch("getUserPermission")
            .then((r) => {
              resolve(res.body, r);
            })
            .catch((err) => {
              reject(err);
            });
          // 获取用户信息
          dispatch("getUserInfo");
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  /**
   * H5跟投登陆操作
   * */
  h5InvestLoginByApp({ commit, dispatch }, token) {
    return new Promise((resolve, reject) => {
      h5InvestLoginByApp(
        {
          clientId: "portal",
        },
        token
      )
        .then((res) => {
          commit("UPDATE_OAUTH", res.body);
          // 获取权限
          dispatch("getUserPermission")
            .then((r) => {
              resolve(res.body, r);
            })
            .catch((err) => {
              reject(err);
            });
          // 获取用户信息
          dispatch("getUserInfo");
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  doLoginByTicket({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      // 验证成功
      loginByOA(params)
        .then((res) => {
          res = res.body;
          commit("UPDATE_OAUTH", res);
          // 获取权限
          dispatch("getUserPermission")
            .then((r) => {
              resolve(res.body, r);
            })
            .catch((err) => {
              reject(err);
            });
          // 获取用户信息
          dispatch("getUserInfo");
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  doLoginByToken({ commit, dispatch }, token) {
    return new Promise((resolve, reject) => {
      // 验证成功
      login({
        grant_type: "refresh_token",
        refresh_token: token,
      })
        .then((res) => {
          res = res.body;
          commit("UPDATE_OAUTH", res);
          // 获取权限
          dispatch("getUserPermission")
            .then((r) => {
              resolve(res.body, r);
            })
            .catch((err) => {
              reject(err);
            });
          // 获取用户信息
          dispatch("getUserInfo");
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  /**
   * 通过wx token登录
   */
  doLoginByWxToken({ commit, dispatch }, token) {
    return new Promise((resolve) => {
      commit("UPDATE_OAUTH", { access_token: token });
      resolve({ access_token: token });
    });
  },
  /**
   * 获取个人信息
   * @param commit
   */
  getUserInfo({ commit }) {
    // 验证成功
    getUserInfo().then((res) => {
      commit("UPDATE_USERDATA", res.body);
    });
  },
  /**
   *  获取个人权限
   */
  getUserPermission({ commit }) {
    return new Promise((resolve, reject) => {
      getUserPermission()
        .then((res) => {
          commit("UPDATE_USER_PERMISSION", res.body);
          resolve(res.body);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  /**
   * 跳转登陆
   */
  goLogin() {
    // 跳转到登录
    // 如果loginType === 'sso'则跳转到oa登陆后再跳回来
    if ($config.loginType === "sso") {
      const href = $config.loginUrl + Base64.encode(window.location.origin + (window.location.pathname || "/") + "#/author");
      console.log("goLogin location", window.location, " href", href);
      window.location.href = href;

      return;
    }

    Router.push({ name: "Login" });
  },
};

const getters = {
  authorization(state) {
    return state.oauth.access_token
      ? "Bearer " + state.oauth.access_token
      : $config.defaultAuthorization;
  },
  userData(state) {
    return state.userData;
  },
  oauth(state) {
    return state.oauth;
  },
};

const mutations = {
  /**
   * 更新oauth相关
   */
  UPDATE_USERDATA(state, data) {
    state.userData = {
      ...data,
    };
    // 存储状态
    mutations["SAVE_USER_TO_LOCAL"](state);
  },
  /**
   * 更新oauth相关
   */
  UPDATE_USER_DATA(state, data) {
    state.userData = { ...data };
    // 存储状态
    mutations["SAVE_USER_TO_LOCAL"](state);
  },
  /**
   * 更新oauth相关
   */
  UPDATE_OAUTH(state, data) {
    state.oauth = { ...data };
    // 存储状态
    mutations["SAVE_USER_TO_LOCAL"](state);
  },
  /**
   * 将user state 数据存储在localstore里面
   */
  SAVE_USER_TO_LOCAL(state) {
    setLocalStorage("user", state);
  },
  /**
   * 从localstorage里取出数据更新user state
   */
  UPDATE_USER_FROM_LOCAL(state) {
    let user = getLocalStorage("user");
    if (user) {
      for (let key in state) {
        state[key] = user[key];
      }
    }
  },
  /**
   * 更新个人权限相关
   * @param state
   * @param data
   */
  UPDATE_USER_PERMISSION(state, data) {
    state.permissionsList = data || [];
    // 存储状态
    mutations["SAVE_USER_TO_LOCAL"](state);
  },
  /**
   * 更新接口权限相关
   * @param state
   * @param data
   */
  UPDATE_USER_URL(state, data) {
    state.dataPermission = data || [];
    // 存储状态
    mutations["SAVE_USER_TO_LOCAL"](state);
  },
  /**
   * 更新当前oss config信息
   * @param satte
   * @param data
   * @constructor
   */
  UPDATE_OSS_TOKEN(state, data) {
    state.ossConfig = { ...data };
    // console.log("ossConfig", state.ossConfig);
  },
};

export default {
  state,
  actions,
  getters,
  mutations,
};
